/*
*  Document   : bootstrap.js
*  Author     : pixelcave
*  Description: Import global dependencies
*
*/

// Import all vital core JS files..
import jQuery from 'jquery';
import SimpleBar from 'simplebar';
import Cookies from 'js-cookie';
import Dropzone from 'dropzone';
import autosize from 'autosize';
import Handlebars from 'handlebars';
import 'bootstrap';
import 'datatables.net-bs4';
import 'datatables.net-buttons';
import 'datatables.net-select';
import 'popper.js';
import 'select2';
import 'magnific-popup';
import 'jquery.appear';
import 'flatpickr';
import 'jquery-scroll-lock';
import 'jquery-ui/ui/widgets/sortable';
import 'bootstrap-notify';
import Swal from 'sweetalert2';
import 'summernote';
import { success, dzUploadError } from '../components';
import Helpers from './modules/helpers';

// ..and assign to window the ones that need it
window.$ = window.jQuery = jQuery;
window.Handlebars = Handlebars;
window.autosize = autosize;
window.Handlebars = Handlebars;
window.Swal = Swal;
window.SimpleBar = SimpleBar;
window.Dropzone = Dropzone;
window.Cookies = Cookies;
window.success = success;
window.dzUploadError = dzUploadError;
window.Helpers = Helpers;
